module.exports = __webpack_public_path__ + "static/media/live-stream-restriction.72da0e0a.png";